import { render, staticRenderFns } from "./MonthlyEISCIMB.vue?vue&type=template&id=45ae221e&scoped=true"
import script from "./MonthlyEISCIMB.vue?vue&type=script&lang=js"
export * from "./MonthlyEISCIMB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ae221e",
  null
  
)

export default component.exports